import Vue from 'vue'
import store from '@/store/'
import {request,setAuthInHeader} from "@/api/request";
import VueJWT from "vuejs-jwt";


let JwtOption = {
    signKey : 'BBuTxhaZyJ81TgrlT3s6N03437S7ZwowxWqiJKmK7NE',
    storage  : 'localStorage',
    keyName  : 'com.dgmong.flyhighadmtoken',  //token 꼭 붙여주세요.
    ignoreExpiration : false,       // set true to ignore expiration date
    ignoreNotBefore  : false,       // set true to ignore 'not before' date
}
Vue.use(VueJWT, JwtOption)

let wcsTimer = null;

export const  getStorageToken =() => { // 토큰 가져오기
    let token = Vue.$jwt.getToken();
    var regex = /"/gi;
    if(!token){
        return null;
    }
    let jwtToken = token.replace(regex,'');
    return jwtToken
}

export const getTokenObj =() => {

    if(Vue.$jwt.hasToken()){
        let jwtToken = getStorageToken();
        let tokenObject = Vue.$jwt.decode(jwtToken,JwtOption.signKey);
        if(jwtToken && tokenObject ){
            return tokenObject;
        } else if(jwtToken){
            return -1;
        }else {
            return null;
        }
    }else {
        return null;
    }

}

export const AuthCheck =() => {

    let tokenObj = getTokenObj();
    if(tokenObj && tokenObj.hasOwnProperty('mb_no')){
        return 1;
    }else if( tokenObj == -1 ){
        logout();
        return null;
    }else{
        return null;
    }


};


export const AuthPayLoad =(wcsTimerCnt,to, from, next) => {

    if(store.getters['common/getUserInfo'] != undefined && store.getters['common/getUserInfo'].mb_no){
        clearInterval(wcsTimer);
        next();
    }else{
        if(wcsTimerCnt >= 3){
            clearInterval(wcsTimer);
            next('/auth');
        }
    }



};


export const authUserInfo =(to, from, next) => { // 토큰이 로컬스토리지에 담겼을 시 사용
    // to: 이동할 url에 해당하는 라우팅 객체
    if (to.matched.some(function(routeInfo) {
        return routeInfo.meta.storeUserInfo;
    })) {
        let wcsTimerCnt = 0;
        // 이동할 페이지에 인증 정보가 필요하면 경고 창을 띄우고 페이지 전환은 하지 않음
        let jwtToken = getStorageToken();
        let userInfoStatus = store.getters['common/getUserInfo'].mb_no;

        if ( !userInfoStatus ) {
            let tokenObj = getTokenObj();
            if(tokenObj && tokenObj.hasOwnProperty('mb_no')){
                let mb_no = tokenObj.mb_no;
                store.dispatch( 'common/setUserInfo', {token : jwtToken, mb_no : mb_no}  );
                wcsTimer = setInterval(function(){
                    if(wcsTimerCnt <= 3 ) { // 1초 동안 리트라이
                        AuthPayLoad(wcsTimerCnt,to, from, next);
                        wcsTimerCnt++;
                    }
                }.bind(this), 1000);
            }else{
                next('/auth');
            }


        } else {
            next();
        }

    } else {
        next(); // 페이지 전환
    };
};

export const loginTokenSet = (token) => {
    Vue.$localStorage.set('token', token);
    setAuthInHeader(token);
}

export const logout = () => {
    Vue.$localStorage.clear(true);
    setAuthInHeader('');
}
